<main class="hero--bg hero pb-6 pb-md-9" id="inhalt">
  <header class="container header-height-inner mb-5 mb-lg-6" [ngClass]="{ limited: !isHeaderNavigationVisible() }">
    <mwe-navbar-header [navigationVisible]="isHeaderNavigationVisible()" />
  </header>
  <section class="container limited">
    <div class="mb-4 text-center">
      <img [src]="'community/community-maintenance.svg' | addStaticImagePath" class="img-fluid w-100" alt="" style="max-width: 558px" />
    </div>
    <div>
      <mwe-basic-card>
        @if (subheadline()) {
          <h1 class="text-md-center mb-3">{{ subheadline() | translate }}</h1>
        }
        @if (text()) {
          <p class="text-body text-md-center mb-0">{{ text() | translate }}</p>
        }
        @if (information()) {
          <p [innerHTML]="information() | translate | safeHtml" class="text-body text-md-center mb-0"></p>
        }
      </mwe-basic-card>
    </div>
  </section>
</main>
